/* unplugin-vue-components disabled */import { render } from "./AskVideo.vue?vue&type=template&id=48df0a10&scoped=true"
import script from "./AskVideo.vue?vue&type=script&lang=js"
export * from "./AskVideo.vue?vue&type=script&lang=js"

import "./AskVideo.vue?vue&type=style&index=0&id=48df0a10&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48df0a10"]])

export default __exports__